"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "CookieStorage", {
  enumerable: true,
  get: function get() {
    return _CookieStorage["default"];
  }
});
Object.defineProperty(exports, "MemoryStorage", {
  enumerable: true,
  get: function get() {
    return _MemoryStorage["default"];
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "isSupported", {
  enumerable: true,
  get: function get() {
    return _isSupported["default"];
  }
});
exports.storage = void 0;
var _isSupported = _interopRequireDefault(require("./isSupported"));
var _CookieStorage = _interopRequireDefault(require("./CookieStorage"));
var _MemoryStorage = _interopRequireDefault(require("./MemoryStorage"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var storage = exports.storage = null;
if ((0, _isSupported["default"])("localStorage")) {
  // use localStorage
  exports.storage = storage = window.localStorage;
} else if ((0, _isSupported["default"])("sessionStorage")) {
  // use sessionStorage
  exports.storage = storage = window.sessionStorage;
} else if ((0, _isSupported["default"])("cookieStorage")) {
  // use cookies
  exports.storage = storage = new _CookieStorage["default"]();
} else {
  // use memory
  exports.storage = storage = new _MemoryStorage["default"]();
}
var _default = exports["default"] = storage;